import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../../utils/helpers/model.helper';
import { EmailDefault } from './email-default.model';

export const EMAIL_DEFAULTS_SCHEMA = Object.freeze({
  USE_DEFAULT: false,
  INCLUDE_PAYMENT_NOTIFICATION: false,
  DEFAULT: EmailDefault,
  INVOICE: EmailDefault,
  ESTIMATE: EmailDefault,
  CREDIT_MEMO: EmailDefault,
  PURCHASE_ORDER: EmailDefault,
  STATEMENT: EmailDefault,
});
const RECORD = generateSchema(EMAIL_DEFAULTS_SCHEMA);
const KEYS: any = generateKeys(EMAIL_DEFAULTS_SCHEMA);

export class EmailDefaults extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));

    const selfModel = setInModel(this, [
      {
        key: KEYS.DEFAULT,
        value: new EmailDefault(this.default),
      },
      {
        key: KEYS.INVOICE,
        value: new EmailDefault(this.invoice),
      },
      {
        key: KEYS.ESTIMATE,
        value: new EmailDefault(this.estimate),
      },
      {
        key: KEYS.CREDIT_MEMO,
        value: new EmailDefault(this.creditMemo),
      },
      {
        key: KEYS.PURCHASE_ORDER,
        value: new EmailDefault(this.purchaseOrder),
      },
      {
        key: KEYS.STATEMENT,
        value: new EmailDefault(this.statement),
      },
    ]);

    return selfModel as EmailDefaults;
  }

  get useDefault(): boolean {
    return this.get(KEYS.USE_DEFAULT);
  }

  get includePaymentNotification(): boolean {
    return this.get(KEYS.INCLUDE_PAYMENT_NOTIFICATION);
  }

  get default(): EmailDefault {
    return this.get(KEYS.DEFAULT);
  }

  get invoice(): EmailDefault {
    return this.get(KEYS.INVOICE);
  }

  get estimate(): EmailDefault {
    return this.get(KEYS.ESTIMATE);
  }

  get creditMemo(): EmailDefault {
    return this.get(KEYS.CREDIT_MEMO);
  }

  get purchaseOrder(): EmailDefault {
    return this.get(KEYS.PURCHASE_ORDER);
  }

  get statement(): EmailDefault {
    return this.get(KEYS.STATEMENT);
  }
}
